import React, { useState, useCallback, useEffect } from "react";
import { CreateUrl } from 'Utils/ApiHelper.js';
import Gallery from "react-photo-gallery";
import FadeIn from "react-fade-in";
import Carousel, { Modal, ModalGateway } from "react-images";
import MaterialButton from '@mui/material/Button';
import Box from '@mui/material/Box';
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import UploadDialog from "./UploadDialog"
import { injectIntl, FormattedMessage, IntlShape, useIntl } from 'react-intl';
import deMessages from "devextreme/localization/messages/de.json";
import frMessages from "devextreme/localization/messages/fr.json";
import esMessages from "devextreme/localization/messages/es.json";
import ptMessages from "devextreme/localization/messages/pt.json";
import { locale, loadMessages } from "devextreme/localization";
import Loader from '../../Utils/Loader/NewLoader2025'
interface Photo {
    src: string;
    height: number;
    width: number;
    caption: string;
    Id: string;
    intl: IntlShape
}

interface TileGalleryProps {
    uploads: any[];
    removeImage: any;
    loggerId: number;
    reloadData: () => void;

}

interface CustomStyles {
    navigationPrev: (base: React.CSSProperties, state: any) => React.CSSProperties;
    navigation: (base: React.CSSProperties, state: any) => React.CSSProperties;
    navigationNext: (base: React.CSSProperties, state: any) => React.CSSProperties;
    container: (base: React.CSSProperties, state: any) => React.CSSProperties;
}

interface FooterProps {
    currentView?: {
        Id: string;
        caption: string;
        // Other properties of your currentView object
    };
}

interface PDFData {
    Caption: string
    ContentType: string
    Filename: string
    FkLCLoggerId: number
    FkLoggerId: number
    FkSiteId : number
    Id: string
    Src: string
}


//Main Function Component
const TileGallery: React.FC<TileGalleryProps> = ({ uploads, removeImage, loggerId, reloadData }) => {
    const intl = useIntl()
//STATES    
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);
    const [hoveredIndex, setHoveredIndex] = useState<null | number>(null);
    const [uploadDialogOpen, setUploadDialogOpen] = useState(false);
    const [photos, setPhotos] = useState<Photo[]>([])
    const [hasImages, setHasImages] = useState<boolean>(false)
    const [hasPdf, setHasPdf] = useState<boolean>(false)
    const [useAzure, setUseAzure] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(true)
    const [pdfs, setpdfs] = useState<PDFData[]>([])
////VARIABLES
//    let hasImages = false;
//    let hasPdf = false;
//    let useAzure = false;


//STYLES FUNCTION FOR REACT-IMAGES
    const customStyles: CustomStyles = {
        navigation: (base) => ({
            ...base,
            background: "none",
        }),
        container: (base) => ({
            ...base,
            width: "600px",
            
        }),
        navigationNext: (base) => ({
            ...base,
            backgroundColor: "#143C67",
            '&:hover': {
                backgroundColor: '#143C67',
                cursor: 'pointer',
                transform: 'scale(1.1)',
            },
        }),
        navigationPrev: (base) => ({
            ...base,
            backgroundColor: "#143C67",
            '&:hover': {
                backgroundColor: '#143C67',
                cursor: 'pointer',
                transform: 'scale(1.1)',
            },
        }),
    };


    


    // fUNCTIONS AND CALLBACKS
    const openLightbox = useCallback(
        (event, { index }) => {
            setCurrentImage(index);
            setViewerIsOpen(true);
        },
        []
    );

    const closeLightbox = (): void => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    const confirmDelete = (Id: string): void => {
        if (window.confirm(intl.formatMessage({ id: "Are you sure you want to delete this item?" }))) {
            removeImage(Id);
            closeLightbox();   
        }
    };
    const confirmDeleteAzure = (Filename: string): void => {
        if (window.confirm(intl.formatMessage({ id: "Are you sure you want to delete this item?" }))) {
            removeImage(Filename);
            closeLightbox();
        }
    };


    const handleDownload = (url: string, filename: string, type: string): void => {
            fetch(url)
                .then(response => response.blob())
                .then(blob => {
                const file = new Blob([blob], { type: type });
                const element = document.createElement("a");
                element.href = URL.createObjectURL(file);
                element.download = filename;
                document.body.appendChild(element);
                element.click();
            })
                .catch(error => console.error('Error fetching the image:', error));
                
    };

    const handlePdfClick = (url: string): void => {
        window.open(url, '_blank');
    };

    const handleMouseEnter = (index: number): void => {
        setHoveredIndex(index);
    };

    const handleMouseLeave = (): void => {
        setHoveredIndex(null);
    };

    const handleUploadButtonClick = (): void => {
        setUploadDialogOpen(true);
    };




    ///useEffect to get image width and height

    useEffect(() => {

        if (!uploads) return



        const imagePromises = uploads
            .filter((obj: any) => obj.ContentType && obj.ContentType !== "application/pdf")
            .map((obj: any) => {

                return new Promise<Photo>((resolve) => {
                    setHasImages(true)

                    if (obj.Filename.indexOf("blob.core.windows.net") > 0) {
                        setUseAzure(true)
                    }

                    const imageSource = useAzure
                        ? obj.Filename
                        : CreateUrl('/api/aquaguard/Images/' + obj.Id)

                    const image = new Image()
                    image.onload = () => {
                        resolve({
                            src: imageSource,
                            height: image.height,
                            width: image.width,
                            caption: obj.Caption,
                            Id: obj.Id,
                            Filename: obj.Filename

                        })
                    }

                    image.onerror = () => {
                        resolve({
                            src: imageSource,
                            height: 9,
                            width: 16,
                            caption: obj.Caption,
                            Id: obj.Id,
                            Filename: obj.Filename

                        })
                    }

                    image.src = imageSource
                })
            })

            Promise.all(imagePromises).then((loadedPhotos) => {
                setPhotos(loadedPhotos)
                setLoading(false)
            })
        const pdfsTemp:PDFData[] = []
        uploads.forEach((obj: any, idx: number) => {
            if (obj.ContentType === 'application/pdf') {
                const url = CreateUrl('/api/aquaguard/Images/' + obj.Id);
                obj.Src = url
                setHasPdf(true)
                pdfsTemp.push(obj)
               
            }
        })
        setpdfs(pdfsTemp)
        
    }, [uploads])




    // PDF'S
    //const documents = uploads.map((obj: any, idx: number) => {
        //if (obj.ContentType === "application/pdf") {
        //    setHasPdf(true)
        //    const url = CreateUrl('/api/aquaguard/Images/' + obj.Id);
        //    return (
        //        <div
        //            key={idx}
        //            style={{ display: "inline-block", position: "relative", height: "150%" }}
        //            onMouseEnter={(): void => handleMouseEnter(idx)}
        //            onMouseLeave={handleMouseLeave}
        //        >
        //            <iframe style={{ border: "none", marginTop: "2px", width: "95%", height: "15em", overflow: "hidden" }} src={`${url}#toolbar=0&navpanes=0&scrollbar=0`} />
        //            {hoveredIndex === idx && (
        //                <div style={{ position: "absolute", top: 0, left: 0, width: "95%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center", background: "#00000090" }}>
        //                    <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
        //                        {obj.Caption && <p style={{ textAlign: "center", color: "white" }}>{obj.Caption.length > 100 ? `${obj.Caption.slice(0, 100)}...` : obj.Caption}</p>}
        //                        <Box sx={{ '& button': { m: 1 } }}>
        //                            <MaterialButton variant="contained" onClick={(): void => handlePdfClick(url)}><FormattedMessage id="View" /></MaterialButton>
        //                            {useAzure && (sessionStorage.getItem("userLevel") === "useradmin" || sessionStorage.getItem("userLevel") === "identityadmin") &&
        //                            <MaterialButton variant="contained" color="error" onClick={(): void => confirmDeleteAzure(obj.Filename)}><FormattedMessage id="Remove" /></MaterialButton>}
        //                            {!useAzure && (sessionStorage.getItem("userLevel") === "useradmin" || sessionStorage.getItem("userLevel") === "identityadmin") &&
        //                            <MaterialButton variant="contained" color="error" onClick={(): void => confirmDelete(obj)}><FormattedMessage id="Remove" /></MaterialButton>}
        //                        </Box>
        //                        {!useAzure &&
        //                            (<Box sx={{ '& button': { m: 1 } }}>
        //                            <MaterialButton variant="contained" color="warning" onClick={(): void => handleDownload(url, obj.Filename, 'application / pdf')}><FormattedMessage id="Download" /></MaterialButton>
        //                            </Box>)}
        //                    </div>
        //                </div>
        //            )}
        //        </div>
        //    );
        //} else {
        //    return null;
        //}
    //});



    // main return
    return (
        <>
            {(loading || (!hasImages && !hasPdf)) &&
                <div>
                    {!hasImages && !hasPdf
                        ? <h4 style={{ textAlign: 'center' }}>No Data</h4>
                        : <h4 style={{ textAlign: 'center' }}>Rendering Images...</h4>}
                </div>}
            {(!loading && (hasImages || hasPdf)) && <div>
                <UploadDialog
                    show={uploadDialogOpen}
                    title="Upload Image"
                    siteId={0}
                    loggerId={loggerId}
                    onSubmit={(): void => {
                        setUploadDialogOpen(false)
                        reloadData()

                    }}
                    onCancel={(): void => setUploadDialogOpen(false)}
                />
                <GridContainer >
                    {hasImages && <GridItem xs={12} sm={12} md={photos.length > 1 && photos.length < 2 || hasPdf ? 6 : 12} >
                        <FadeIn>
                            <div className="homeContainer" >
                                <h2><FormattedMessage id="Images" /></h2>

                                <Gallery photos={photos as Photo[]} onClick={openLightbox} />
                                <ModalGateway>
                                    {viewerIsOpen ? (
                                        <Modal onClose={closeLightbox}>
                                            <Carousel
                                                currentIndex={currentImage}
                                                styles={customStyles}

                                                views={photos.map(x => ({
                                                    ...x,
                                                    srcset: x.srcSet,
                                                }))}
                                                components={{
                                                    Footer: ({ currentView }) => (
                                                        
                                                        <div style={{ display: "flex", justifyContent: "space-around" }}>
                                                            <div style={{ margin: '0 auto', textAlign: 'center', position: "absolute", bottom: "100px", zIndex: 1000000 }}>
                                                                {currentView?.caption && <p style={{ color: 'white' }}>{currentView?.caption}</p>}
                                                                <Box sx={{ '& button': { m: 1 } }}>

                                                                    {!useAzure && (<MaterialButton
                                                                        variant="contained"
                                                                        color="warning"
                                                                        onClick={(): void => handleDownload(currentView?.src, currentView?.Filename, 'image / jpeg')}
                                                                    >
                                                                        <FormattedMessage id="Download" />
                                                                    </MaterialButton>)}

                                                                    {sessionStorage.getItem("canConfig") === "true" &&
                                                                        <MaterialButton variant="contained" color="error" onClick={(): void => confirmDelete(currentView)}>
                                                                            <FormattedMessage id="Remove" />
                                                                        </MaterialButton>}
                                                                </Box>
                                                            </div>
                                                        </div>
                                                    ),

                                                }}
                                            />
                                        </Modal>
                                    ) : null}
                                </ModalGateway>
                            </div>
                        </FadeIn>
                    </GridItem>}
                    {hasPdf && <GridItem xs={12} sm={12} md={6}>
                        <h2>PDF&apos;s</h2>
                        <div style={{ display: "flex", flexWrap: "wrap", overflowX: "auto" }}>
                            {pdfs.map((obj: PDFData, idx: number) => {
                                return (
                                    <div
                                        key={idx}
                                        style={{ display: "inline-block", position: "relative", height: "150%" }}
                                        onMouseEnter={(): void => handleMouseEnter(idx)}
                                        onMouseLeave={handleMouseLeave}
                                    >
                                        <iframe
                                            style={{
                                                border: "none",
                                                marginTop: "2px",
                                                width: "100%",
                                                height: "15em",
                                                overflow: "hidden"
                                            }} src={`${obj.Src}#toolbar=0&navpanes=0&scrollbar=0`}
                                        />
                                        {hoveredIndex === idx && (
                                            <div style={{ position: "absolute", top: 0, left: 0, width: "95%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center", background: "#00000090" }}>
                                                <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                                                    {obj.Caption && <p style={{ textAlign: "center", color: "white" }}>{obj.Caption.length > 100 ? `${obj.Caption.slice(0, 100)}...` : obj.Caption}</p>}
                                                    <Box sx={{ '& button': { m: 1 } }}>
                                                        <MaterialButton variant="contained" onClick={(): void => handlePdfClick(obj.Src)}><FormattedMessage id="View" /></MaterialButton>
                                                        {useAzure && (sessionStorage.getItem("userLevel") === "useradmin" || sessionStorage.getItem("userLevel") === "identityadmin") &&
                                                        <MaterialButton variant="contained" color="error" onClick={(): void => confirmDeleteAzure(obj.Filename)}><FormattedMessage id="Remove" /></MaterialButton>}
                                                        {!useAzure && (sessionStorage.getItem("userLevel") === "useradmin" || sessionStorage.getItem("userLevel") === "identityadmin") &&
                                                        <MaterialButton variant="contained" color="error" onClick={(): void => confirmDelete(obj)}><FormattedMessage id="Remove" /></MaterialButton>}
                                                    </Box>
                                                    {!useAzure &&
                                                        (<Box sx={{ '& button': { m: 1 } }}>
                                                        <MaterialButton variant="contained" color="warning" onClick={(): void => handleDownload(obj.Src, obj.Filename, 'application / pdf')}><FormattedMessage id="Download" /></MaterialButton>
                                                        </Box>)}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                )
                            })}
                        </div>
                    </GridItem>}
                </GridContainer>
            </div>}
        </>
            );

}

export default injectIntl(TileGallery)
